import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, interval, map, of, take } from 'rxjs';
import { RuntimeDataTestWorkflowUpdate } from 'src/app/interfaces/runtime-data.interface';
import { getUUID } from 'src/app/utils/id-utils/id.utils';

@Injectable({
	providedIn: 'root',
})
export class SignalRService {
	public get connectionId() {
		return 'connectionId';
	}

	private runtimeDataUpdatesSubject: BehaviorSubject<RuntimeDataTestWorkflowUpdate> =
		new BehaviorSubject<RuntimeDataTestWorkflowUpdate>(null);
	public get runtimeDataUpdates$(): Observable<RuntimeDataTestWorkflowUpdate> {
		return this.runtimeDataUpdatesSubject.asObservable();
	}

	public get workspaceDisableTriggered$(): Observable<string> {
		return of(null);
	}

	// Emits GUIDs in pattern: A, A, B, B, C, C...
	// One value is emitted every 15 seconds until 120 emissions (30 minutes)
	public get runtimeDataEntryCreated$(): Observable<string> {
		return interval(15_000).pipe(
			take(120),
			map(n => getUUID(`RuntimeDataEntryCreated::${Math.floor(n / 2)}`))
		);
	}

	public resetRuntimeDataEntry() {}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
